import * as React from 'react'
import { RouteComponentProps, Route } from 'react-router'
import { ApplicationState } from '../../store'
import { useSelector } from 'react-redux'
import AdminCoreInfo from './AdminCoreInfo'
import AdminContacts from './AdminContacts'
import AdminContracting from './AdminContracting'
import AdminStaff from './AdminStaff'
import AdminDefaultSettings from './AdminDefaultSettings'
import { Link } from 'react-router-dom'
import AdminBookingsCustomInputs from './AdminBookingsCustomInputs'
import AdminExternalMappings from './AdminExternalMappings'

interface Props extends RouteComponentProps<{ tab: string }> { }
const urls = [
    { url: 'core', name: 'Core Info', component: AdminCoreInfo },
    { url: 'contacts', name: 'Contacts', component: AdminContacts },
    { url: 'contracting', name: 'Contracting', component: AdminContracting },
    { url: 'staff', name: 'Staff', component: AdminStaff },
    { url: 'defaultsettings', name: 'Default Settings', component: AdminDefaultSettings },
    { url: "externalmappings", name: "External Mappings", component: AdminExternalMappings },
    { url: 'bookingscustominputs', name: 'Bookings Custom Inputs', component: AdminBookingsCustomInputs }
]
const AdminLayout = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const authData = useSelector((state: ApplicationState) => state.auth.authData)
    const allowedUrls = React.useMemo(() => {
        let _allowedUrls = urls;
        if (!authData?.isExternalIntegrations) {
            _allowedUrls = _allowedUrls.filter(x => x.url != "externalMappings")
        }
        return _allowedUrls;
    }, [authData])
    return (
        <div className="tabs-wrapper is-vertical">
            <div className="tab-head">
                {allowedUrls.map((url, index) => (
                    <Link key={index} to={url.url}>
                        <div
                            key={url.url}
                            className={`tab-head-item${url.url == props.match.params.tab ? ' is-active' : ''}`}
                        >
                            {Localization.getString(url.name)}
                        </div>
                    </Link>
                ))}
            </div>
            <div className="tab-content-wrap">
                {allowedUrls.map((url, index) => (
                    <Route key={index} path={`/admin/${url.url}`} component={url.component} />
                ))}
            </div>
        </div>
    )
}
export default AdminLayout
